export const DEFAULT_SIZES = {
  solid: {
    0: 0.654394693200663,
    1: 0.288557213930348,
    2: 0.654394693200663,
    3: 0.654394693200663,
    4: 0.735323383084577,
    5: 0.654394693200663,
    6: 0.654394693200663,
    7: 0.654394693200663,
    8: 0.654394693200663,
    9: 0.654394693200663
  },
  outline: {
    0: 0.654394693200663,
    1: 0.288557213930348,
    2: 0.654394693200663,
    3: 0.654394693200663,
    4: 0.734991708126036,
    5: 0.654394693200663,
    6: 0.654394693200663,
    7: 0.654394693200663,
    8: 0.654394693200663,
    9: 0.654394693200663
  },
  promesh: {
    0: 0.42,
    1: 0.25,
    2: 0.42,
    3: 0.42,
    4: 0.5233333333333333,
    5: 0.42,
    6: 0.42,
    7: 0.42,
    8: 0.42,
    9: 0.42
  },
  emilio: {
    0: 0.654394693200663,
    1: 0.288557213930348,
    2: 0.654394693200663,
    3: 0.654394693200663,
    4: 0.734991708126036,
    5: 0.654394693200663,
    6: 0.654394693200663,
    7: 0.654394693200663,
    8: 0.654394693200663,
    9: 0.654394693200663
  },
  squaresbold: {
    0: 0.912037037037037,
    1: 0.628571428571428,
    2: 0.912037037037037,
    3: 0.912037037037037,
    4: 0.952380952380952,
    5: 0.912037037037037,
    6: 0.912037037037037,
    7: 0.912037037037037,
    8: 0.912037037037037,
    9: 0.912037037037037
  },
  beantown: {
    0: 0.818181818181818,
    1: 0.459595959595959,
    2: 0.818181818181818,
    3: 0.818181818181818,
    4: 0.848484848484848,
    5: 0.818181818181818,
    6: 0.818181818181818,
    7: 0.818181818181818,
    8: 0.818181818181818,
    9: 0.818181818181818
  },
  octinsports: {
    0: 0.657142857142857,
    1: 0.366666666666666,
    2: 0.657142857142857,
    3: 0.657142857142857,
    4: 0.657142857142857,
    5: 0.657142857142857,
    6: 0.657142857142857,
    7: 0.657142857142857,
    8: 0.657142857142857,
    9: 0.657142857142857
  },
  rueckwarzsalto: {
    0: 0.471615720524017,
    1: 0.247787610619469,
    2: 0.471615720524017,
    3: 0.471615720524017,
    4: 0.5,
    5: 0.471615720524017,
    6: 0.471615720524017,
    7: 0.471615720524017,
    8: 0.471615720524017,
    9: 0.471615720524017
  },
  facon: {
    0: 0.90497737556561,
    1: 0.627906976744186,
    2: 0.90497737556561,
    3: 0.90497737556561,
    4: 0.866666666666666,
    5: 0.90497737556561,
    6: 0.90497737556561,
    7: 0.90497737556561,
    8: 0.90497737556561,
    9: 0.90497737556561
  },
  varsityteam: {
    0: 0.642857142857142,
    1: 0.361904761904761,
    2: 0.642857142857142,
    3: 0.642857142857142,
    4: 0.642857142857142,
    5: 0.642857142857142,
    6: 0.642857142857142,
    7: 0.642857142857142,
    8: 0.642857142857142,
    9: 0.642857142857142
  },
  soccerleague: {
    0: 0.653846153846153,
    1: 0.447115384615384,
    2: 0.653846153846153,
    3: 0.653846153846153,
    4: 0.620192307692307,
    5: 0.653846153846153,
    6: 0.653846153846153,
    7: 0.653846153846153,
    8: 0.653846153846153,
    9: 0.653846153846153
  },
  niconne: {
    0: 0.946564885496183,
    1: 0.552,
    2: 0.775193798449612,
    3: 0.946564885496183,
    4: 0.8515625,
    5: 0.887218045112781,
    6: 0.946564885496183,
    7: 0.745901639344262,
    8: 0.946564885496183,
    9: 0.946564885496183
  }
};
const STYLE_KEYS = Object.keys(DEFAULT_SIZES);

export function calculateSizes({ style, height, quantities }) {
  const sanitizedStyle = style === "none" ? STYLE_KEYS[0] : style.replace(/-/g, "");
  const styleSizes = DEFAULT_SIZES[sanitizedStyle];

  return Object.keys(quantities).reduce((acct, size) => {
    if (!size) return acct;
    return {
      ...acct,
      [size]: {
        height,
        width: styleSizes[size] * height
      }
    };
  }, {});
}
